import { TranslationModel } from '@/core/domain/translation/models/translation.model';

export const loadReducer = (
    _: TranslationModel,
    { value }: { value: TranslationModel },
): TranslationModel => value;
